import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TellentMembersEffects } from './store/tellent-members.effects';
import { TellentMembersNamespace, TellentMembersReducer } from './store/tellent-members.store';

@NgModule({
  imports: [
    StoreModule.forFeature(TellentMembersNamespace, TellentMembersReducer),
    EffectsModule.forFeature([TellentMembersEffects]),
  ],
})
export class TellentMembersDataModule {}
